import { Schema } from "effect"
import { Engine } from "./engine.js"

// ============================================================
// Transform API
// ============================================================

/**
 * Transform request - execute XSLT transformation
 */
export const TransformRequest = Schema.Struct({
  xml: Schema.String,
  xsl: Schema.String,
  engine: Schema.optional(Engine),
  systemId: Schema.optional(Schema.String),
})
export type TransformRequest = typeof TransformRequest.Type

/**
 * Transform response
 */
export const TransformResponse = Schema.Struct({
  success: Schema.Boolean,
  result: Schema.optional(Schema.String),
  error: Schema.optional(Schema.String),
  engine: Schema.optional(Engine),
  transformationTime: Schema.optional(Schema.Number),
  messages: Schema.optional(Schema.Array(Schema.String)),
})
export type TransformResponse = typeof TransformResponse.Type

// ============================================================
// Save/Load Fiddle API
// ============================================================

/**
 * Save fiddle request
 */
export const SaveFiddleRequest = Schema.Struct({
  xml: Schema.String,
  xsl: Schema.String,
  engine: Schema.optional(Engine),
  systemId: Schema.optional(Schema.String),
  id_slug: Schema.optional(Schema.String),
})
export type SaveFiddleRequest = typeof SaveFiddleRequest.Type

/**
 * Save fiddle response
 */
export const SaveFiddleResponse = Schema.Struct({
  success: Schema.Boolean,
  id: Schema.optional(Schema.String),
  revision: Schema.optional(Schema.Number),
  transformation: Schema.optional(TransformResponse),
  error: Schema.optional(Schema.String),
})
export type SaveFiddleResponse = typeof SaveFiddleResponse.Type

/**
 * Fiddle data returned from load endpoint
 */
export const FiddleData = Schema.Struct({
  shortId: Schema.optional(Schema.String),
  revision: Schema.optional(Schema.Number),
  xml: Schema.optional(Schema.String),
  xsl: Schema.optional(Schema.String),
  result: Schema.optional(Schema.NullOr(Schema.String)),
  engine: Schema.optional(Schema.String),
  systemId: Schema.optional(Schema.String),
  createdAt: Schema.optional(Schema.String),
  transformationTime: Schema.optional(Schema.Number),
  success: Schema.optional(Schema.Boolean),
  errorMessage: Schema.optional(Schema.NullOr(Schema.String)),
})
export type FiddleData = typeof FiddleData.Type

/**
 * Load fiddle response
 */
export const FiddleResponse = Schema.Struct({
  success: Schema.Boolean,
  fiddle: Schema.optional(FiddleData),
  error: Schema.optional(Schema.String),
})
export type FiddleResponse = typeof FiddleResponse.Type

/**
 * Fiddle list item (for listing endpoints)
 */
export const FiddleListItem = Schema.Struct({
  shortId: Schema.String,
  revision: Schema.Number,
  engine: Engine,
  createdAt: Schema.String,
  updatedAt: Schema.optional(Schema.String),
  success: Schema.Boolean,
})
export type FiddleListItem = typeof FiddleListItem.Type

// ============================================================
// PDF API
// ============================================================

/**
 * PDF generation request
 */
export const PdfRequest = Schema.Struct({
  xslfo: Schema.String,
  filename: Schema.optional(Schema.String),
  config: Schema.optional(
    Schema.Record({ key: Schema.String, value: Schema.String })
  ),
})
export type PdfRequest = typeof PdfRequest.Type

/**
 * PDF generation response
 */
export const PdfResponse = Schema.Struct({
  success: Schema.Boolean,
  pdfContent: Schema.optional(Schema.NullOr(Schema.String)),
  generationTime: Schema.optional(Schema.Number),
  error: Schema.optional(Schema.NullOr(Schema.String)),
  contentLength: Schema.optional(Schema.Number),
  filename: Schema.optional(Schema.NullOr(Schema.String)),
  mimeType: Schema.optional(Schema.String),
  fopVersion: Schema.optional(Schema.String),
})
export type PdfResponse = typeof PdfResponse.Type

// ============================================================
// Defaults API
// ============================================================

/**
 * Default content response
 */
export const DefaultsResponse = Schema.Struct({
  success: Schema.Boolean,
  xml: Schema.String,
  xsl: Schema.String,
})
export type DefaultsResponse = typeof DefaultsResponse.Type
